<template>
  <div class="app-navbar">
    <b-container fluid>
      <b-row>
        <!-- & NEW APPNav -->
        <b-col v-if="devDesign" cols="7">
          <b-nav justified style="background: transparent; padding: 3px; height: 25px; font-size: 10pt" :class="modalTheme">
            <b-nav-item active-class="worklists-active" :class="modalTheme" to="/landing">Landing</b-nav-item>
            <b-nav-item active-class="worklists-active" to="/emr/Dashboard">X Dashboard</b-nav-item>
            <b-nav-item active-class="worklists-active" to="/emr/patients">X Patients</b-nav-item>

            <b-nav-item active-class="worklists-active" to="/emr/NIHCodeLookup">X Code Lookup</b-nav-item>
            <b-nav-item active-class="worklists-active" to="/emr/announcements">X Announcements</b-nav-item>
            <b-nav-item active-class="worklists-active" v-show="showHCC" :to="{ path: HCCUrl }">X Plan</b-nav-item>

            <b-nav-item to="/scheduler">Scheduler</b-nav-item>
            <b-nav-item active-class="worklists-active" to="/blank">BLANK DEV</b-nav-item>
            <b-nav-item active-class="worklists-active" to="/masterPatientList">MASTER</b-nav-item>
          </b-nav>
        </b-col>
        <!-- // ^ current -->
        <b-col v-if="!devDesign" cols="7">
          <b-nav justified style="padding: 3px; height: 25px; font-size: 10pt" :class="modalTheme">
            <!-- <b-nav-item active-class="worklists-active" :class="modalTheme" to="/landing">Landing</b-nav-item> -->

            <b-nav-item active-class="worklists-active" to="/emr/patients">Patients</b-nav-item>


            <b-nav-item active-class="worklists-active" to="/emr/Dashboard">Dashboard</b-nav-item>
            <!-- <b-nav-item active-class="worklists-active" to="/Reporting" v-show="hasFullPatientChart">Reporting</b-nav-item> -->
            <b-nav-item active-class="worklists-active" to="/emr/NIHCodeLookup">Code Lookup</b-nav-item>

            <b-nav-item active-class="worklists-active" v-show="showHCC" :to="{ path: HCCUrl }">Plan</b-nav-item>
            <!-- <b-nav-item active-class="worklists-active" to="/emr/announcements">Announcements</b-nav-item> -->
          </b-nav>
        </b-col>

        <!-- <b-col v-if="devDesign" cols="2" style="background: transparent; color: red; padding: 0px; height: 25px">
          <span style="color: green">_user: {{ userStore._user.devExTheme }}</span> <br />
          {{ userStore.devExTheme }}
        </b-col> -->
        <!-- <b-col cols="1"> </b-col> -->
        <b-col style="background: transparent; padding: 0px; padding-right: 00px; height: 100%">
          <div id="view" :class="userStore.borderClass" style="width: 275px; margin-right: 5px; height: 25px; margin-left: auto">
            <h6 class="dashONEInfoBar">{{ currentDate }}</h6>
          </div>
        </b-col>

        <!-- <b-col cols="6" v-if="isDASHRoute"> -->
        <!-- <h4 style="background:darkturquoise;color:cyan;">isDASHRoute {{ isDASHRoute }}</h4> -->
        <!-- <h4 v-show="isDASHRoute" style="background:red;color:yellow;"> >> isDASHRoute {{ isDASHRoute }}</h4> -->
        <!-- <DashboardInfoBar /> -->

        <!-- <div class="text-right"><h6 style="color:#123486;font-size:8pt;">TODAY is {{ currentDate }}</h6></div> -->
        <!-- </b-col> -->
      </b-row>
    </b-container>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import moment from "moment";
// import { extendMoment } from 'moment-range'
// var moment = extendMoment(moment)
const currentDate = moment(Date.now()).format("dddd, MMMM D, YYYY");
// console.log(">>> currentDate : ", currentDate);

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
// * STORE
import { usePatientStore } from "@/stores/patientStore";
const patientStore = usePatientStore();

const devDesign = computed(() => {
  // return userStore._user.name === "thopper@innovarehealth.com";
  return false;
});

const AreIdsShown = ref(true);
const currentTheme = ref("generic-light"); //  or "generic-dark"

// * a computed ref
const HCCUrl = computed(() => {
  return patientStore.currentPatient ? `/emr/Patient/${patientStore.currentPatient.personID}` : "";
});
// console.log("HCCUrl");
// console.log(HCCUrl);

const showHCC = computed(() => {
  return patientStore.currentPatientId ? true : false;
});

const modalTheme = computed(() => userStore.bModalTheme);

onMounted(() => {
  // console.log("onMounted() :      APP NAV BAR >>>>");
  // console.log("				showHCC");
  // console.log(showHCC.value);
});
</script>

<style lang="scss" scoped>
.app-navbar {
  padding: 3px;
  //  height: 3em;
  // border-radius: 15px;
  //  background-color: #eaf7eb; //#43997848; // ? Simulated OPACITY
  //  color: #dcf1de; //  white; // #42948248;
  // font-size: 14px;
  // margin-left: -1rem;
  // margin-right: -1rem;
  // margin-bottom: 0.25rem;
}

.appNavContainer {
  // background-color: #43997848; // ? Simulated OPACITY
  // background-color:#43997848;
  color: #6e796f;
  // height: 100%;
}

.navCont .nav-link .nav-pills {
  //line-height: 40px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  text-align: center;
  // color: orange;
  //  font-size: 0.75rem;
  // border-radius: 10px 0px 0px 10px;
  // height: 140px;
  //  width: 20px;
  //width: 300px;
  color: #123486;
  // border-radius: 10px 0px 0px 10px;
  background-color: transparent;
}

.nav-link {
  display: block;
  padding-top: 0px;
  padding-bottom: 0px;
  padding: 0%;
  //width: 130px;
  //  line-height: 1.75;
}

.nav-link:hover,
.nav-link:focus {
  //  background-color: #caeacd;
  //  color: #123486;
  border-radius: 0px 0px 0px 0px;
}

.navCont .nav-link .nav-pills {
  line-height: 40px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  text-align: center;
  // color: orange;
  font-size: 1rem;
  border-radius: 10px 0px 0px 10px;
  // height: 140px;
  width: 30px;
  width: 300px;
  color: #123486;
  border-radius: 10px 0px 0px 10px;
  background-color: transparent;
}

.nav-pills {
  background-color: transparent; // #c6d9c8;
}

.nav-pills .nav-link.active {
  // background-color: #a5dbaa;
  // color: #123486; // #dcf1de;//#eaf7ebc8;
  // font-weight: bold;
  // // border: 3px ridge #a5dbaa8e;
  // // border: 4mm ridge rgba(211, 220, 50, .6);
  // border-radius: 5px 0px 0px 5px;
  // // border: 3px solid transparent;
  // border-width: 3px 0px 3px 6px;
  // font-weight: bolder;
  -webkit-box-shadow: 1px 0px 0px 0px transparent inset; //b0c1b2
  box-shadow: 1px 0px 0px 0px transparent inset; //b0c1b2

  //  color: #eef8e//f;
  //  background-color: #b0c1b2;
  border-radius: 5px 5px 5px 5px;
  // border-radius: 5px 5px 5px 5px;
  // border-width: 3px 0px 3px 6px;
  font-weight: bolder;
}

.nav-pills .nav-link {
  border-radius: 6px;
  text-align: center;
}

.nav-link {
  display: block;
  padding-top: 0px;
  padding-bottom: 0px;
  padding: 0%;
  width: 100px;
  line-height: 1.75;
}

.nav-link:hover,
.nav-link:focus {
  //  background-color: #caeacd;
  //  color: #123486;
  border-radius: 0px 0px 0px 0px;
}

// .d-block {
// 	color: red;
// }
.dashBoard {
  border: 3px solid #069e7d;
  padding: 15px;
  border-radius: 10px;
  // background-color: #0d463a;
}

// .dashForm {
// 	border: 2px solid lime;
// 	padding: 15px;
// 	border-radius: 10px;
// 	background-color: #74b9aa;
// }
.bg-light {
  background-color: #b6e6dc !important;
}

.calendar {
  margin: 0 auto !important;
}

.main-container.calendar.multiple {
  width: 100%;
}

.modal-calendar {
  width: 1000px;
}

.quote {
  background-color: #5f1010;
  padding: 6px;
}

.dashONEInfoBar {
  height: 15px;
  /* width: 420px; */
  border-radius: 5px;
  //  background-color: #b0c1b2; //#c6d9c8;
  // color: red;
  //  border: 0.25px solid #c6d9c8;
  text-align: center;
  font-size: 10pt;
  font-weight: normal;
  padding-top: 3px;
}

#head-navbar {
  width: 100%;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
}
.nav > li {
  display: inline-block;
  width: initial;
  float: left;
  white-space: nowrap;
}
</style>
